export default __webpack_public_path__ + "static/media/geofenceMarkerCallout_Nay.0f29fe43.svg";